
function getConfig(){
    // config object that contains the configuration of the search bar
    let config = {
        searchBar: document.querySelector('.beneficiary-search-bar'),
        searchInput: document.querySelector('.beneficiary-search-bar input.keywords'),
        searchButton: document.querySelector('.beneficiary-search-bar button[type="submit"]')
    }

    config.resultsContainer = config.searchBar.getAttribute('data-resultsid') ? 
    document.querySelector(`#${config.searchBar.getAttribute('data-resultsid')}`) : 
    document.querySelector('#org-results-container')

    config.customDomain = config.searchBar.getAttribute('data-customdomain') ? config.searchBar.getAttribute('data-customdomain') : false

    config.customCallback = config.searchBar.getAttribute('data-customcallback') ? config.searchBar.getAttribute('data-customcallback') : false

    config.filters = config.searchBar.getAttribute('data-filters') ? true : false

    config.parent = config.searchBar.getAttribute('data-parent') ? config.searchBar.getAttribute('data-parent') : null

    config.type = config.searchBar.getAttribute('data-type') ? config.searchBar.getAttribute('data-type') : null

    config.resultsClass = config.searchBar.getAttribute('data-resultsclass') ? config.searchBar.getAttribute('data-resultsclass') : null

    config.linkType = config.searchBar.getAttribute('data-linktype') ? config.searchBar.getAttribute('data-linktype') : null

    config.linkCustom = config.searchBar.getAttribute('data-linkcustom') ? config.searchBar.getAttribute('data-linkcustom') : null

    config.buttonText = config.searchBar.getAttribute('data-buttontext') ? config.searchBar.getAttribute('data-buttontext') : null

    config.context = config.searchBar.getAttribute('data-context') ? config.searchBar.getAttribute('data-context') : 'page'

    config.navType = config.searchBar.getAttribute('data-navtype') ? config.searchBar.getAttribute('data-navtype') : "oneOf"

    config.location = config.searchBar.getAttribute('data-location') ? true : false

    config.resultsCount = config.searchBar.getAttribute('data-resultscount') ? true : false

    config.autoLoad = config.searchBar.getAttribute('data-autoload') ? true : false

    config.reloadConfig = config.searchBar.getAttribute('data-reloadconfig') ? true : false

    config.customNoImg = config.searchBar.getAttribute('data-customnoimg') ? config.searchBar.getAttribute('data-customnoimg') : "img/no-image.png"

    config.keywordsBlacklist = config.searchBar.getAttribute('data-keywordsblacklist') ? config.searchBar.getAttribute('data-keywordsblacklist').split(", ") : null

    config.scrollto = config.searchBar.getAttribute('data-scrollto') ? config.searchBar.getAttribute('data-scrollto'): null

    config.extraItem = config.searchBar.getAttribute('data-extra-item') ? document.querySelector(config.searchBar.getAttribute('data-extra-item')): null

    config.customNoResults = config.searchBar.getAttribute('data-customnoresults') ? document.querySelector(config.searchBar.getAttribute('data-customnoresults')): null

    return config;
}

// function thats loads the items from the server and renders them
async function loadItems(config){

    if(config.reloadConfig){
        config = getConfig();
    }
    const {resultsContainer, parent, filters, resultsClass, linkType, linkCustom, buttonText, context, navType, resultsCount, location, customNoImg, scrollto, type } = config;

    // delete placeholder
    if(document.querySelector('#org-results-defaults')){
        document.querySelector('#org-results-defaults').style.display = "none"
    }

    // clear previous results
    resultsContainer.innerHTML = ""

    // create loading animation
    if(!document.querySelector("#loaderAnim")){
        
        let elem = document.createElement('div')
        elem.id = "loaderAnim"
        elem.classList.add('text-center', 'big-top-margin')
        elem.innerHTML = '<span class="fa fa-2x fa-refresh fa-spin"></span>'

        resultsContainer.appendChild(elem)
    }

    try{
        
        // api request to get the items
        let apiUrl = (config.customDomain ? config.customDomain : '')+"/api/v2/organizations-search/"

        if(window.location.search !== "") {
            apiUrl += window.location.search
        }else{
            throw new Error('no search params provided')
        }

        apiUrl += parent ? `&parent=${parent}` : ""

        if(type){
            let types=type.split(',');
            types.forEach((element) => {
                apiUrl += `&types=${element}`
            })
        }

        const response = await fetch(apiUrl, {
            method: 'GET',
            headers: {
                accept: 'application/json'
            },
        });

        if(response.status !== 200){
            throw new Error('Error while fetching data from the server')
        }

        const data = await response.json();        

        // render search tags if needed
        if(filters){

            // create header text
            let header = document.createElement('h3')
            header.classList.add('header-small')
            header.innerText = "Wyniki wyszukiwania"
            resultsContainer.appendChild(header)

            // create search tags container
            let tags = document.createElement('div')
            tags.classList.add('criteria-labels')

            // map through the search params
            let searchParams = new URLSearchParams(window.location.search)
            searchParams.forEach((value, key) => {

                // if it is filter make sure that it is checked in the list
                if(key !== "keywords" && key !== "page"){
                    document.querySelector(`#${key.replaceAll("_", "")}${value}`).checked = true
                }

                // create element if its not a page param
                if(key !== "page") {

                    let tag = document.createElement('div')
                    tag.classList.add('criteria')
                    tag.innerHTML = `<span class="name">${key === "keywords" ? value : document.querySelector(`label[for=${key.replaceAll("_", "")}${value}]`).innerText}</span>
                    <div class="close" data-type="${key}" data-value="${value}"></div>`

                    // add event listener to the close button
                    tag.querySelector('.close').addEventListener('click', (e) => {

                        let searchParams = new URLSearchParams(window.location.search)
                        searchParams.delete(e.target.getAttribute('data-type'), e.target.getAttribute('data-value'))
                        searchParams.delete("page")
                        window.history.pushState({}, null,  `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`)

                        if(e.target.getAttribute('data-type') !== "keywords" && key !== "page"){
                            document.querySelector(`#${key.replaceAll("_", "")}${value}`).checked = false
                        }

                        loadItems(config)
                    })

                    tags.appendChild(tag)
                }
            })

            resultsContainer.appendChild(tags)
        }

        // create results container
        let results = document.createElement('div')
        results.classList.add('results', "row", "organizations")
        resultsClass ? results.classList.add(resultsClass) : null

        // map through the results items
        if(data.organizations.count > 0){
            // render the items
            data.organizations.items.forEach((i) => {

                // create item element
                let orgItem = document.createElement('div')
                // orgItem.classList.add('col-xs-6', 'col-sm-3', 'col-md-3', 'result', 'result-inline', 'organization')
                orgItem.classList.add('col-6', 'col-sm-3', 'col-md-3', 'result', 'result-inline', 'organization')
                
                // fill the item with data
                orgItem.innerHTML = `<div class="resultInner"><div class="wrap"><a href="${linkType === "custom" ? `${linkCustom}?beneficiary_id=${i.id}` : i.url}" data-beneficiary-id="${i.id}" data-beneficiary-name="${i.name.replace(/"/g, "&#34;")}">
                <div class="image-wrap-new" style="background-image: url(${(i.thumbnail ? i.thumbnail : STATIC_URL+customNoImg)}); background-position: center center; background-size: contain; background-repeat: no-repeat;">
                </div><p class="name">${i.name}</p>${location ? `<p class="location">${i.post_code} ${i.post_town}, ${i.province}</p>` : ""} ${buttonText ? `<div class="overlay">
                <span class="btn btn-red" data-analytics="beneficiary_choose" data-analytics-value="${i.id}" data-beneficiary-id="${i.id}" data-beneficiary-name="${i.name.replace(/"/g, "&#34;")}">${buttonText}</span></div></a></div></div>` : "</a></div></div>"}`

                results.appendChild(orgItem)
            })

            if(config.extraItem){
                results.appendChild(config.extraItem);
            }
        }else{
            if(config.customNoResults){
                results.innerHTML = config.customNoResults.innerHTML
            } else {
                // create no results message
                results.innerHTML = `<div class="row results organizations">
                <div class="col-xs-12 text-center">
                <p>${window.jsLocale.search_noresults_1}</p>
                <p>${window.jsLocale.search_noresults_2}</p>
                </div></div>`
                if(config.extraItem){
                    results.innerHTML += '<div class="row results organizations no-results justify-content-center">'+config.extraItem.outerHTML+'</div>';
                    
                } 
            }
            
        }
        resultsContainer.appendChild(results)

        // create pagination if needed
        if(data.organizations.max_pages > 1){

            // create ui element
            let elem = document.createElement('div')
            elem.classList.add('col-xs-12')

            switch(navType){
                case "select":
                    elem.innerHTML = `<nav>
                    <ul class="pagination justify-content-center mt-4" style="font-weight: bold">
                    <li class="${!data.organizations.previous && "disabled"} arrow page-item" data-pagination-nextprev="previous" aria-label="${window.jsLocale.pagination_prev}">
                    <span class="link page-link border-0">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M3.21938 12.531L9.96937 19.281C10.1101 19.4218 10.301 19.5008 10.5 19.5008C10.699 19.5008 10.8899 19.4218 11.0306 19.281C11.1714 19.1403 11.2504 18.9494 11.2504 18.7504C11.2504 18.5514 11.1714 18.3605 11.0306 18.2198L5.56031 12.7504H20.25C20.4489 12.7504 20.6397 12.6714 20.7803 12.5307C20.921 12.3901 21 12.1993 21 12.0004C21 11.8015 20.921 11.6107 20.7803 11.4701C20.6397 11.3294 20.4489 11.2504 20.25 11.2504H5.56031L11.0306 5.78104C11.1714 5.64031 11.2504 5.44944 11.2504 5.25042C11.2504 5.05139 11.1714 4.86052 11.0306 4.71979C10.8899 4.57906 10.699 4.5 10.5 4.5C10.301 4.5 10.1101 4.57906 9.96937 4.71979L3.21938 11.4698C3.14964 11.5394 3.09432 11.6222 3.05658 11.7132C3.01884 11.8043 2.99941 11.9019 2.99941 12.0004C2.99941 12.099 3.01884 12.1966 3.05658 12.2876C3.09432 12.3787 3.14964 12.4614 3.21938 12.531Z" fill="#111111"/>
                        </svg>
                    </span>
                    </li>
                    <li class="page-item disabled dotted">
                    <ul class=" list-unstyled d-flex border-0">
                    ${data.organizations.max_pages > 5 && data.organizations.page > 2 ? '<li class="page-listItem" >1</li>' : ``}
                    ${data.organizations.page - 4 > 0 && data.organizations.page + 1 > data.organizations.max_pages ? '<li class="page-listItem">' + (data.organizations.page - 4) + '</li>': ``}
                    ${data.organizations.page - 3 > 0 && data.organizations.page + 2 > data.organizations.max_pages ? '<li class="page-listItem">' + (data.organizations.page - 3) + '</li>' : ``}
                    ${data.organizations.page - 2 > 0 && data.organizations.page + 3 > data.organizations.max_pages ? '<li class="page-listItem">' + (data.organizations.page - 2) + '</li>' : ``}
                    ${data.organizations.page - 1 > 0 ? '<li class="page-listItem">' + (data.organizations.page - 1) + '</li>' : ``}
                    ${'<li class="page-listItem" style="color: #E40147; border: 1px solid #E40147;">' + data.organizations.page + '</li>'}
                    ${data.organizations.page + 1 <= data.organizations.max_pages ? '<li class="page-listItem">' + (data.organizations.page + 1) + '</li>' : ``}
                    ${data.organizations.page + 2 <= data.organizations.max_pages ? '<li class="page-listItem">' + (data.organizations.page + 2) + '</li>' : ``}
                    ${data.organizations.page + 3 <= data.organizations.max_pages && data.organizations.page - 1 <= 0   ?'<li class="page-listItem">' +  (data.organizations.page + 3) + '</li>' : ``}
                    ${data.organizations.max_pages > 5 && data.organizations.page < 3 ? '<li class="page-listItem" >5</li>' : ``}
                    ${data.organizations.page + 3 <= data.organizations.max_pages ? '<li class="page-listItem">' + data.organizations.max_pages + '</li>' : ""}
                    </ul>
                    </li>
                    <li class="${!data.organizations.next && "disabled"} arrow page-item" data-pagination-nextprev="next" aria-label="${window.jsLocale.pagination_next}">
                    <span class="link page-link border-0">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <path d="M20.7806 12.531L14.0306 19.281C13.8899 19.4218 13.699 19.5008 13.5 19.5008C13.301 19.5008 13.1101 19.4218 12.9694 19.281C12.8286 19.1403 12.7496 18.9494 12.7496 18.7504C12.7496 18.5514 12.8286 18.3605 12.9694 18.2198L18.4397 12.7504H3.75C3.55109 12.7504 3.36032 12.6714 3.21967 12.5307C3.07902 12.3901 3 12.1993 3 12.0004C3 11.8015 3.07902 11.6107 3.21967 11.4701C3.36032 11.3294 3.55109 11.2504 3.75 11.2504H18.4397L12.9694 5.78104C12.8286 5.64031 12.7496 5.44944 12.7496 5.25042C12.7496 5.05139 12.8286 4.86052 12.9694 4.71979C13.1101 4.57906 13.301 4.5 13.5 4.5C13.699 4.5 13.8899 4.57906 14.0306 4.71979L20.7806 11.4698C20.8504 11.5394 20.9057 11.6222 20.9434 11.7132C20.9812 11.8043 21.0006 11.9019 21.0006 12.0004C21.0006 12.099 20.9812 12.1966 20.9434 12.2876C20.9057 12.3787 20.8504 12.4614 20.7806 12.531Z" fill="#111111"/>
                        </svg>
                    </span>
                    </li></ul></nav>`
                    break;
                case "oneOf":
                default:
                    elem.innerHTML = `<nav>
                    <ul class="pagination justify-content-center mt-2">
                    <li class="${!data.organizations.previous && "disabled"} arrow page-item" data-pagination-nextprev="previous" aria-label="${window.jsLocale.pagination_prev}">
                    <span class="link page-link">&lt;</span>
                    </li>
                    <li class="page-item disabled dotted">
                    <span class="page-link page-text">${window.jsLocale.pagination_page} ${data.organizations.page} ${window.jsLocale.pagination_of} ${data.organizations.max_pages}</span>
                    </li>
                    <li class="${!data.organizations.next && "disabled"} arrow page-item" data-pagination-nextprev="next" aria-label="${window.jsLocale.pagination_next}">
                    <span class="link page-link">&gt;</span>
                    </li></ul></nav>`
                    break;
            }

            
            // event handler for page buttons
            let changePage = (e) => {

                if(Array.from(e.currentTarget.classList).indexOf('disabled') === -1){

                    let newUrl = `${window.location.origin}${window.location.pathname}`

                    if(e.currentTarget.classList.contains('page-listItem')){
                        let searchParams = new URLSearchParams(window.location.search)
                        searchParams.set("page", e.currentTarget.innerText)
                        newUrl = newUrl + "?" + searchParams.toString()
                    }else{
                        let linkToApi = data.organizations[e.currentTarget.attributes['data-pagination-nextprev'].value.toLowerCase()]
                        newUrl = newUrl + linkToApi.slice(linkToApi.indexOf('?'))
                    }

                    window.history.pushState({}, null, newUrl )
                    switch(context){
                        case "modal":
                            document.querySelector('#beneficiary-select-modal-abovesearchresults').parentElement.scrollTo({top: document.querySelector('#beneficiary-select-modal-abovesearchresults').offsetHeight, left: 0, behavior: "smooth"})
                            break;
                        case "landing":
                            resultsContainer.scrollIntoView()
                            break;
                        case "page":
                        default:
                            window.scrollTo(0,0)
                            break;  
                    }
                    loadItems(config)
                }

            }   

            // add event listeners
            elem.querySelector('li[data-pagination-nextprev="previous"]').addEventListener('click', changePage)
            elem.querySelector('li[data-pagination-nextprev="next"]').addEventListener('click', changePage)
            elem.querySelectorAll('.page-listItem').forEach((i) => i.addEventListener('click', changePage))


            resultsContainer.appendChild(elem)
        }

        // create  results counter if needed
        if(resultsCount){

            // create ui element
            let elem = document.createElement('div')
            elem.classList.add('col-xs-12')

            elem.innerHTML = `<p class="text-center" style="font-weight: bold; margin-bottom: 32px;">Liczba wyników: ${data.organizations.total} </p>`

            resultsContainer.prepend(elem)
        }

        // remove loader
        document.querySelector("#loaderAnim").remove()

        // scroll to the results
        if(scrollto){
            document.querySelector(scrollto).scrollIntoView({behavior: "smooth"})
        }

    }catch(e){

        //console.error('error', e)

        // clear results if errour occured
        resultsContainer.innerHTML = ""

        // show defualt results
        if(document.querySelector('#org-results-defaults')){
            document.querySelector('#org-results-defaults').style.display = "block"
        }
    }

    if(config.customCallback){
        try{
            window[config.customCallback]();
        }catch(e){
            console.log('customCallback error');
            console.log(e);
        }
    }

}

let config = getConfig();
// load items if autoload is set to true
if(config.autoLoad) loadItems(config)



async function searchHandler(searchQuery, searchParams){
    const {searchBar, searchInput, searchButton, keywordsBlacklist} = config

    // check if the input value is empty
    if(searchQuery.length > 0){
        // delete previous page param
        searchParams.delete("page")

        // check if the search query has any blacklisted keywords
        if(keywordsBlacklist && keywordsBlacklist.length > 0){
            for(let i of keywordsBlacklist){
                if(` ${searchQuery} `.toLowerCase().includes(` ${i} `)){
                    let reg = new RegExp(` ${i} `, "gi")
                    searchQuery = ` ${searchQuery} `.replace(reg, "").trim()
                }
            }
        }
        // add param to the url
        searchParams.set("keywords", searchQuery)
        window.history.pushState({}, null,  `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`)

        // load search results
        loadItems(config)

    }else{

        // remove param from the url
        searchParams.delete("keywords")
        window.history.pushState({}, null,  `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`)

        // load search results
        loadItems(config)

    }
}

// function that handles the search bar
async function searchBarHandler(){

    const {searchBar, searchInput, searchButton, keywordsBlacklist} = config

    

    // if keywords are already in the url populate the search bar
    let searchParams = new URLSearchParams(window.location.search)
    if(searchParams.has("keywords")){
        searchInput.value = searchParams.get("keywords")
    }

    

    // add event listener to the search bar
    searchBar.addEventListener('submit', async (e) => {
        e.preventDefault()
        let searchQuery = searchInput.value.trim()
        searchHandler(searchQuery, searchParams)
    });

    
    if(searchBar.nodeName=='DIV'){
        searchInput.addEventListener('keyup', async (e) => {
            e.preventDefault()
            let searchQuery = searchInput.value.trim()
            if (e.key === 'Enter' || e.keyCode === 13) {
                searchHandler(searchQuery, searchParams)
            }
        });

        searchButton.addEventListener('click', async (e) => {
            e.preventDefault()
            let searchQuery = searchInput.value.trim()
            searchHandler(searchQuery, searchParams)
        });
        
    }
    

    // delete loading animation
    try{
        searchBar.querySelector('.loading-overlay').remove()
        searchBar.querySelector('.btn').removeAttribute('disabled')
    } catch(e){
        // no .loading-overlay or .btn
    }
    
    searchBar.removeAttribute('disabled')

}   

searchBarHandler()

// function that handles the filters
async function filtersHandler(){

    // map through the checkboxes
    document.querySelectorAll('.form-check-input').forEach((i) => {

        // add event listener to the checkboxes
        i.addEventListener('change', async (e) => {

            // get the search params
            let searchParams = new URLSearchParams(window.location.search)

            // check the type of the checkbox
            let type = ""
            switch (e.target.id.slice(0, 3)){
                case "fie":
                    type = "fields_of_action"
                    break;
                case "org":
                    type = "organization_types"
                    break;
                case "geo":
                    type = "geographical_scopes"
                    break; 
            }

            // add or remove the param from the url
            if(e.target.checked){
                searchParams.append(type, e.target.value)
            }else{
                searchParams.delete(type, e.target.value)
            }
            searchParams.delete("page")


            window.history.pushState({}, null,  `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`)

            loadItems(config)
        })
    })
}

if(config.filters) filtersHandler()